import Aion from '@adoratorio/aion';

const raf = new Aion({ autostop: false });

export default raf;
